export enum RelationshipType {
  Self = 0,
  Child = 1,
  Parent = 2
}
